// Locale master data (docs/architecture.md §7a, §8). Orgs pick from these; nothing here is a
// UTC offset, only IANA zone names, so 2026-style rule changes need a tzdata update, not code.
export const LANGUAGES = ['en-CA', 'fr-CA'];
/** Default zone for an org in each province or territory (province pack master data). */
export const PROVINCE_TIME_ZONES = {
    NL: 'America/St_Johns',
    NS: 'America/Halifax',
    PE: 'America/Halifax',
    NB: 'America/Moncton',
    QC: 'America/Toronto',
    ON: 'America/Toronto',
    MB: 'America/Winnipeg',
    SK: 'America/Regina',
    AB: 'America/Edmonton',
    BC: 'America/Vancouver',
    YT: 'America/Whitehorse',
    NT: 'America/Yellowknife',
    NU: 'America/Iqaluit',
};
/** Canadian zones offered in pickers, with names people recognize, in both languages. */
export const CANADIAN_TIME_ZONES = [
    { zone: 'America/St_Johns', en: "Newfoundland (St. John's)", fr: 'Terre-Neuve (St. John’s)' },
    {
        zone: 'America/Goose_Bay',
        en: 'Labrador (Happy Valley-Goose Bay)',
        fr: 'Labrador (Happy Valley-Goose Bay)',
    },
    { zone: 'America/Halifax', en: 'Atlantic (Halifax)', fr: 'Atlantique (Halifax)' },
    { zone: 'America/Moncton', en: 'Atlantic (Moncton)', fr: 'Atlantique (Moncton)' },
    { zone: 'America/Toronto', en: 'Eastern (Toronto, Montréal)', fr: 'Est (Toronto, Montréal)' },
    { zone: 'America/Winnipeg', en: 'Manitoba (Winnipeg)', fr: 'Manitoba (Winnipeg)' },
    { zone: 'America/Regina', en: 'Saskatchewan (Regina)', fr: 'Saskatchewan (Regina)' },
    { zone: 'America/Edmonton', en: 'Alberta (Edmonton)', fr: 'Alberta (Edmonton)' },
    {
        zone: 'America/Vancouver',
        en: 'British Columbia (Vancouver)',
        fr: 'Colombie-Britannique (Vancouver)',
    },
    { zone: 'America/Whitehorse', en: 'Yukon (Whitehorse)', fr: 'Yukon (Whitehorse)' },
    {
        zone: 'America/Yellowknife',
        en: 'Northwest Territories (Yellowknife)',
        fr: 'Territoires du Nord-Ouest (Yellowknife)',
    },
    { zone: 'America/Iqaluit', en: 'Nunavut (Iqaluit)', fr: 'Nunavut (Iqaluit)' },
];
export const WEEK_STARTS = ['sunday', 'monday'];
/** `auto` follows the language: 12-hour in English, 24-hour in French. */
export const TIME_FORMATS = ['auto', '12h', '24h'];
//# sourceMappingURL=locale.js.map